import script from "./region-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./region-item.vue?vue&type=script&setup=true&lang=ts"

import "./region-item.vue?vue&type=style&index=0&id=0c9fba9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9fba9a"]])

export default __exports__